import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { InjectionToken, Provider } from '@angular/core';
import { Router } from '@angular/router';
import { OktaInterceptor } from '@app/auth/okta/interceptors/okta.interceptor';
import { AUTH_SERVICE, IAuthService } from '@auth/index';
import { AuthConfig } from '@core/models/config.models';
import { OktaAuthGuard, OKTA_AUTH, OKTA_CONFIG } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';

export function getOktaProviders(config: AuthConfig): Provider[] {
  const AUTH_CONFIG = new InjectionToken<AuthConfig>('auth_config', {
    factory: () => config,
  });

  return [
    {
      provide: OKTA_AUTH,
      useFactory: OktaInstanceFactory,
      deps: [AUTH_CONFIG, Router],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useFactory: OktaInterceptorConfigFactory,
      deps: [OKTA_AUTH, AUTH_SERVICE, Router],
      multi: true,
    },
    {
      provide: OKTA_CONFIG,
      useFactory: OktaConfigFactory,
      deps: [OKTA_AUTH],
    },
    OktaAuthGuard,
  ];
}

export function OktaInstanceFactory(
  config: AuthConfig,
  router: Router
): OktaAuth {
  return new OktaAuth({
    clientId: config.clientId,
    issuer: config.authority,
    redirectUri: config.redirectUri,
    postLogoutRedirectUri: config.redirectUri,
    scopes: config.scopes.split(','),
    restoreOriginalUri: async (_oktaAuth, originalUri) => {
      // Navigate to the original URI or default to home after login
      router.navigateByUrl(originalUri || '/', { replaceUrl: true });
    },
  });
}

export function OktaInterceptorConfigFactory(
  oktaAuth: OktaAuth,
  authService: IAuthService,
  router: Router
): OktaInterceptor {
  return new OktaInterceptor(oktaAuth, authService, router);
}

export function OktaConfigFactory(oktaAuth: OktaAuth): { oktaAuth: OktaAuth } {
  return { oktaAuth };
}
